export enum MutationTypes {
  SAVE_FATE = 'SAVE_FATE',
  RESET_COUNTER = 'RESET_COUNTER',
}

export default MutationTypes;
